import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--right",
  "use": "icon-slider--right-usage",
  "viewBox": "0 0 10 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 16\" id=\"icon-slider--right\"><path d=\"M1.177 1.743A.751.751 0 0 1 2.237.68l6.365 6.364a1.25 1.25 0 0 1 0 1.768l-6.011 6.01a.75.75 0 0 1-1.06-1.06L6.833 8.46a.75.75 0 0 0 0-1.06L1.177 1.743Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol